/**
*
*   Examples
*       -
*
**/
'use client';


import Button from '@/components/button';
import Image from '@/components/image';
import CtaButton from '@/components/business/cta-button';
import { useState, useLayoutEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslations } from 'next-intl';
//import 'swiper/css';

//Build the Element
export default function Examples({ title = false, settings = {}, data = [], ...props }){

	//Use Translations
	const t = useTranslations();

	//The Reference
	const ref = useRef();

	//Set the Point State
	const [point, setPoint] = useState({ state: false });

	//Swiper
	const [swiper, setSwiper] = useState({
		instance:   null,
		first:      true,
		last:       false
	});

	//Paramenters
	const Parameters = Object.assign({

		//Swiper Settings
		spaceBetween:   10,
		breakpoints:    {
			0: {
				slidesPerView: 1
			},
			600: {
				slidesPerView: 2
			},
			800: {
				slidesPerView: 3
			}
		},

		onSwiper: swiper => setSwiper({
			instance:       swiper,
			first:          swiper.isBeginning,
			last:           swiper.isEnd
		}),

		onSlideChange: swiper => setSwiper({
			instance:       swiper,
			first:          swiper.isBeginning,
			last:           swiper.isEnd
		}),

		onTransitionEnd: swiper => setSwiper({
			instance:       swiper,
			first:          swiper.isBeginning,
			last:           swiper.isEnd
		}),

		onResize: swiper => setSwiper({
			instance:       swiper,
			first:          swiper.isBeginning,
			last:           swiper.isEnd
		})

	},settings);


	/**
	*
	*   Resize the nav to the center of the categories
	*
	**/
	useLayoutEffect( () => {

		/**
		*
		*  RESIZER
		*   - The Resizer Function to align the nav to the center of the image
		*
		*   Params:
		*       n/a
		**/
		const obj = {
			resizer: (e) => {

				const $container  = ref.current,
					$nav        = $container.querySelector('nav.controls'),
					height      = $container.querySelectorAll('img')[0].offsetHeight;

				$nav.style.top = `${ ( height / 2 ) + ( $container.querySelector('header')?.offsetHeight || 0 )   }px`;

			}
		};

		//Add the resizer event
		window.addEventListener('resize', obj.resizer );

		//Dispatch the event to start it
		obj.resizer();

		//Cleanup
		return () => window.removeEventListener('resize', obj.resizer );

	},[point]);

	//Return
	return (
		<section id="examples" className="container" ref={ ref }>
			{ title && (
				<header>
					<h2>{ title }</h2>
				</header>
			)}
			<Swiper { ...Parameters } className="list">{
				data.map( (row , i) => (
					<SwiperSlide key={i}>
						<Image src={ row.image } alt="" width="329" height="400" />
						<div>
							<h3>{ row.title }</h3>
							<p>{ row.description }</p>
							<div className="buttons">
								<CtaButton type={ row.type } value={ ( row?.value ?? 100 ) } size="small">{ row.button }</CtaButton>
							</div>
						</div>
					</SwiperSlide>
				))
			}</Swiper>
			<nav className="controls">
				<Button onClick={ () => swiper.instance.slidePrev() } hidden={ swiper.first }>
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
						<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
						<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</Button>
				<Button onClick={ () => swiper.instance.slideNext() } hidden={ swiper.last }>
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
						<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
						<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</Button>
			</nav>
		</section>
	);

}